const HealthActionBar = ({ onAction = (actionKey) => { } }) => {

    return (
        <div className="h5 d-flex  align-items-start mt-2 py-2 ">
            <button className="btn btn-dark" onClick={() => onAction('LOCALIZE')} >
                <i className="fa-solid fa-location-crosshairs "></i>
            </button>

            <button className="btn btn-dark mx-2 text-success" onClick={() => onAction('CALL')} >
                <i className="fa-solid fa-phone "></i>
            </button>

            <button className="btn btn-dark mx-2 text-danger" onClick={() => onAction('ALARM')} >
                <i className="fa-solid fa-podcast"></i>
            </button>
            <button className="btn btn-dark mx-2" onClick={() => onAction('SYNC')} >
                <i className="fa-solid fa-rotate"></i>
            </button>
        </div>
    );
}

export default HealthActionBar 